const localization = {
    body: {
        emptyDataSourceMessage: "Aucun élément",
        addTooltip: "Ajouter",
        deleteTooltip: "Supprimer",
        editTooltip: "Ajouter à la liste",
        filterRow: {
            filterTooltip: "Filtrer"
        },
        editRow: {
            deleteText: "Êtes-vous sûr de vouloir supprimer cet élément ?",
            cancelTooltip: "Annuler",
            saveTooltip: "Valider"
        }
    },
    grouping: {
        placeholder: "Drag headers..."
    },
    header: {
        actions: "Actions"
    },
    pagination: {
        labelDisplayedRows: "{from}-{to} sur {count}",
        labelRowsSelect: "lignes",
        labelRowsPerPage: "Lignes par page:",
        firstAriaLabel: "Première page",
        firstTooltip: "Première page",
        previousAriaLabel: "Page précédente",
        previousTooltip: "Page précédente",
        nextAriaLabel: "Page suivante",
        nextTooltip: "Page suivante",
        lastAriaLabel: "Dernière page",
        lastTooltip: "Dernière page"
    },
    toolbar: {
        addRemoveColumns: "Afficher/masquer des colonnes",
        nRowsSelected: "{0} ligne(s) selectionnée(s)",
        showColumnsTitle: "Afficher les colonnes",
        showColumnsAriaLabel: "Afficher les colonnes",
        exportTitle: "Exporter",
        exportAriaLabel: "Exporter",
        exportName: "Exporter en CSV",
        searchTooltip: "Rechercher",
        searchPlaceholder: "Rechercher"
    }
};

export default localization;
